import { validateRedirectPath } from "@/config/auth";

/**
 * Single source of truth for the role -> surface mapping (TD-016).
 * Used by the PWA launch resolver, the workspace chooser, and every
 * post-login redirect so a role never falls into the wrong surface.
 */
export function portalSurfacePath(role: string, clientId: string): string {
  if (role === "creator") return `/creator/${clientId}`;
  if (role === "editor") return `/editor/${clientId}`;
  return `/client/${clientId}`;
}

/**
 * Where to land after a login mints a session (DD-026). A ?redirect=
 * deep link is honored only when it points at the SAME workspace and
 * the surface matching the session's role — a creator session never
 * follows a /client deep link (the bug class where share/bounce
 * redirects stranded creators on the client portal). Anything else
 * falls back to the role's home surface.
 */
export function resolvePostLoginTarget(
  rawRedirect: string | null,
  clientId: string,
  role: string
): string {
  const validated = validateRedirectPath(rawRedirect);
  if (validated) {
    const base = validated.split("?")[0];
    const segments = base.split("/").filter(Boolean);
    const surface =
      role === "creator" ? "creator" : role === "editor" ? "editor" : "client";
    if (segments[0] === surface && segments[1] === clientId) {
      return validated;
    }
  }
  return portalSurfacePath(role, clientId);
}
